import { STUDIO_API_BASE_URL_V5 } from '../config';

export const ClusterAPIRoutes = {
  identifyCluster: () => `${STUDIO_API_BASE_URL_V5}/identity_cluster`,
};
